#import "./SageGiftAccountDifferenceFields.graphql"

mutation ReopenSageGiftAccountDifferences($ids: [ID!]!) {
  reopenSageGiftAccountDifferences(input: { ids: $ids }) {
    results {
      id
      success
      error
      difference {
        ...SageGiftAccountDifferenceFields
      }
    }
  }
}
